import React, { useState, useEffect } from 'react';
import { Input, InputGroup, InputGroupText, FormGroup, Label } from 'reactstrap';

import axios from 'axios';
import config from "../../config"; // Certifique-se de que o caminho esteja correto
import { useCookies } from "react-cookie";

import AsyncSelect from 'react-select/async';
import InputSelectCustom from './InputSelectCustom';


export const ComboboxIntercambio = ({ ID_Empresa, ID_Empresa_Parceira, ID_Documento_Grupo, onChange, value }) => {

  const [cookie] = useCookies(['_csrf_token']);
  const [allOptions, setAllOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(value || null);

  // Carrega plantas quando o ID_Empresa muda
  useEffect(() => {
   if (ID_Empresa !== null || ID_Empresa_Parceira !== null || ID_Documento_Grupo !== null) {
      const fetchIntercambio = async () => {
        try {
          const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
            proc: 'FRONT_Permissao_Obter_Intercambio',
            requestData: { 
              "ID_Empresa": ID_Empresa ,  
              "ID_Empresa_Parceira": ID_Empresa_Parceira ,  
              "ID_Documento_Grupo": ID_Documento_Grupo }
          }, {
            headers: {
              "X-CSRF-Token": cookie?._csrf_token
            }
          });

          const intercambioData = response.data.map(intercambio => ({
            value: intercambio.ID_Intercambio,
            label: intercambio.Intercambio
          }));

          setAllOptions(intercambioData);

          // Se não houver valor inicial, define a primeira planta da lista como selecionada
          if (!value && intercambioData.length > 0) {
            setSelectedOption(intercambioData[0]);
            onChange(intercambioData[0]);
          }
        } catch (err) {
          console.error("Erro ao carregar plantas:", err);
        }
      };

      fetchIntercambio();
    }
  }, [ID_Empresa, cookie, value, onChange]);

  // Função para carregar opções dinamicamente no AsyncSelect
  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = allOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    } else {
      callback(allOptions);
    }
  };

  return (
    <div className="mb-3">
      <AsyncSelect
        cacheOptions
        defaultOptions={allOptions}
        loadOptions={loadOptions}
        onChange={(selected) => {
          setSelectedOption(selected);
          onChange(selected); // Propaga a mudança ao componente pai
        }}
        value={selectedOption}
        placeholder="Selecione um intercambio"
        isClearable={true}
        styles={{
          menu: (provided) => ({
            ...provided,
            overflowY: 'auto', // Apenas a rolagem interna, sem altura fixa
          }),
          control: (provided) => ({
            ...provided,
            width: '100%' // Garante que o combobox ocupe toda a largura do contêiner
          })
        }}
      />
    </div>
  );
};

export const InputEmailUsuario = ({ onResult, onReset }) => {
    const [email, setEmail] = useState('');
    const [usuario, setUsuario] = useState({ ID_Usuario: '', Nome_Completo: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isVerified, setIsVerified] = useState(false); // Para mudar o ícone para check verde
    const [cookie] = useCookies(['_csrf_token']);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setIsVerified(false);
        setError(null);
        setUsuario({ ID_Usuario: '', Nome_Completo: '' });
        onReset(); // Reseta o formulário no componente pai
    };

    const handleSearch = async () => {
        if (!email) {
            setError('Email não pode estar vazio.');
            return;
        }

        try {
            setLoading(true);
            const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
                proc: 'FRONT_Permissao_Obter_Usuario',
                requestData: { "Email": email }
            }, {
                headers: {
                    "X-CSRF-Token": cookie?._csrf_token
                }
            });

            if (response.data && response.data.length > 0) {
                const { ID_Usuario, Nome_Completo } = response.data[0];
                setUsuario({ ID_Usuario, Nome_Completo });
                onResult({ ID_Usuario, Nome_Completo, Email: email });
                setIsVerified(true);
            } else {
                setError('Nenhum usuário encontrado com este email.');
                setIsVerified(false);
            }
        } catch (err) {
            console.error("Erro ao buscar usuário:", err);
            setError('Erro ao buscar usuário. Tente novamente.');
            setIsVerified(false);
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
      setEmail('');
      setUsuario({ ID_Usuario: null, Nome_Completo: null });
      setIsVerified(false);
      setError(null);
      onResult({ ID_Usuario: null }); 
      onReset(); // Reseta o formulário no componente pai
    };

    return (
        <FormGroup>
            <Label for="Email">Email</Label>
            <InputGroup>
                <Input
                    type="email"
                    name="Email"
                    id="Email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Digite o email"
                    required
                />
                <InputGroupText onClick={handleSearch} style={{ cursor: 'pointer' }}>
                    {isVerified ? (
                        <i className="fas fa-check" style={{ color: 'green' }}></i>
                    ) : (
                        <i className="fas fa-search"></i>
                    )}
                </InputGroupText>
                {email && (
                    <InputGroupText onClick={handleClear} style={{ cursor: 'pointer' }}>
                        <i className="fas fa-times" style={{ color: 'red' }}></i>
                    </InputGroupText>
                )}
            </InputGroup>
            {loading && <p>Carregando usuário...</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
            {usuario.ID_Usuario && (
                <FormGroup id="dados-user"><br/>
                    <Label for="Usuario">Usuário</Label>
                    <Input
                        type="text"
                        id="Usuario"
                        value={`${usuario.ID_Usuario} - ${usuario.Nome_Completo}`}
                        disabled
                    />
                </FormGroup>
            )}
        </FormGroup>
    );
};



export const InputEmailUsuario_old = ({ onResult, onReset }) => {
    const [email, setEmail] = useState('');
    const [usuario, setUsuario] = useState({ ID_Usuario: '', Nome_Completo: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isVerified, setIsVerified] = useState(false); // Para mudar o ícone para check verde
    const [cookie] = useCookies(['_csrf_token']);

    // Limpa o estado do usuário ao digitar um novo e-mail
    const handleEmailChange = (e) => {
      setEmail(e.target.value);
      setIsVerified(false);  // Resetar a verificação ao alterar o email
      setError(null);  // Limpa o erro quando o valor muda
      setUsuario({ ID_Usuario: '', Nome_Completo: '' });
      onReset(); // Reseta o formulário no componente pai
    };

    const handleSearch = async () => {
      if (!email) {
        setError('Email não pode estar vazio.');
        return;
      }

      try {
        setLoading(true);
        const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
          proc: 'FRONT_Permissao_Obter_Usuario',
          requestData: { "Email": email }
        }, {
          headers: {
            "X-CSRF-Token": cookie?._csrf_token
          }
        });

        if (response.data && response.data.length > 0) {
          const { ID_Usuario, Nome_Completo } = response.data[0];
          setUsuario({ ID_Usuario, Nome_Completo });
          onResult({ ID_Usuario, Nome_Completo, Email: email });
          setIsVerified(true); // Marca o ícone como verificado
        } else {
          setError('Nenhum usuário encontrado com este email.');
          setIsVerified(false); // Não marca o ícone
        }
      } catch (err) {
        console.error("Erro ao buscar usuário:", err);
        setError('Erro ao buscar usuário. Tente novamente.');
        setIsVerified(false); // Não marca o ícone
      } finally {
        setLoading(false);
      }
    };

    return (
      <FormGroup>
        <Label for="Email">Email</Label>
        <InputGroup>
          <Input
            type="email"
            name="Email"
            id="Email"
            value={email}
            onChange={handleEmailChange}
            placeholder="Digite o email"
            required
          />
          <InputGroupText onClick={handleSearch} style={{ cursor: 'pointer' }}>
            {isVerified ? (
              <i className="fas fa-check" style={{ color: 'green' }}></i>
            ) : (
              <i className="fas fa-search"></i>
            )}
          </InputGroupText>
        </InputGroup>
        {loading && <p>Carregando usuário...</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}
       {usuario.ID_Usuario && (
          <FormGroup><br/>
            <Label for="Usuario">Usuário</Label>
            <Input
              type="text"
              id="Usuario"
              value={`${usuario.ID_Usuario} - ${usuario.Nome_Completo}`}
              disabled
            />
          </FormGroup>
        )}
      </FormGroup>
    );
};

export const ComboboxEmpresaParceira = ({ ID_Usuario, onChange, value }) => {

  console.log('ComboboxEmpresa', value)

  const [cookie] = useCookies(['_csrf_token']);
  const [allOptions, setAllOptions] = useState([]);
  const [displayedOptions, setDisplayedOptions] = useState([]);
  const [displayCount, setDisplayCount] = useState(10); // Inicialmente exibe 10 itens
  const [selectedOption, setSelectedOption] = useState(value || null); // Seta o valor inicial

  // Efeito para buscar todas as opções quando o valor inicial não estiver disponível
  useEffect(() => {
    if (value === null) {// Se já tivermos o valor inicial, não fazemos a consulta à API
      const fetchAllOptions = async () => {
        try {

          const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
            proc: 'FRONT_Permissao_Obter_Empresa_Parceira',
            requestData: { "ID_Usuario": ID_Usuario, query: '' }
          }, {
            headers: {
              "X-CSRF-Token": cookie?._csrf_token
            }
          });

          const empresasOptions = response.data.map((empresa) => ({
            value: empresa.ID_Empresa_Parceira,
            label: empresa.Empresa_Parceira,
          }));

          setAllOptions(empresasOptions); // Salva todas as opções de empresa
          setDisplayedOptions(empresasOptions.slice(0, displayCount)); // Mostra apenas os primeiros itens
        } catch (error) {
          console.error("Erro ao carregar empresas:", error);
        }
      };

      fetchAllOptions();
    } else {
      // Se o valor já foi passado, setamos ele diretamente
      setSelectedOption(value);
    }
  }, [ID_Usuario, cookie, displayCount, value]);

  // Função para carregar as opções conforme o usuário digita
  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = allOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    } else {
      callback(displayedOptions);
    }
  };

  // Função para carregar mais opções ao rolar a lista
  const handleScroll = () => {
    const nextCount = displayCount + 10;
    const newOptions = allOptions.slice(0, nextCount);
    setDisplayedOptions(newOptions);
    setDisplayCount(nextCount);
  };

  return (
    <div className="mb-3">
      <InputSelectCustom
        name={"Empresa Parceira"}
        stateSelected={selectedOption}
        optionsData={displayedOptions}
        placeholder="Selecione uma empresa parceira"
        isClearable={true}
        loadOptions={loadOptions}
        handleOnMenuScrollToBottom={handleScroll}
        handleOnChange={(selected) => {
          setSelectedOption(selected); // Atualiza o estado local
          onChange(selected); // Propaga a mudança ao componente pai
        }}
      />
    </div>
  );
};


export const SwitchVisivel = ({ isChecked, onClick }) => {
  return (
    <div className="form-check form-switch mb-3">
      <input
        type="checkbox"
        className="form-check-input"
        id="switchVisivel"
        checked={isChecked} // O estado 'isChecked' controla a marcação do checkbox
        onClick={onClick}  // Aqui usamos onClick ao invés de onChange
      />
      <label className="form-check-label" htmlFor="switchVisivel">
        Visível
      </label>
    </div>
  );
};




export const SwitchAtivo = ({ isChecked, onChange }) => {
  return (
    <div className="form-check form-switch mb-3">
      <input
        type="checkbox"
        className="form-check-input"
        id="switchAtivo"
        checked={isChecked}
        onChange={onChange}
      />
      <label className="form-check-label" htmlFor="switchAtivo">
        Ativo
      </label>
    </div>
  );
};



export const ComboboxIntercambio_direto = ({ onChange }) => {
  const [cookie] = useCookies(['_csrf_token']);

  const loadOptions = async (inputValue, callback) => {
    if (inputValue.length < 3) {
      return callback([]); // Retorna um array vazio se menos de 3 letras forem digitadas
    }

    try {
      const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
        proc: 'FRONT_Permissao_Obter_Intercambio',
        requestData: {"1": inputValue }
      }, {
        headers: {
          "X-CSRF-Token": cookie?._csrf_token
        }
      });

      const options = response.data.map((inter) => ({
        value: inter.ID_Intercambio,
        label: inter.Intercambio,
      }));

      callback(options);
    } catch (err) {
      console.error("Erro ao carregar intercâmbios:", err);
      callback([]); // Retorna um array vazio em caso de erro
    }
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      onChange(selectedOption);  // Passa o objeto selecionado adiante
    } else {
      onChange(null);  // Trata o caso de seleção ser desmarcada (se `isClearable` estiver ativado)
    }
  };

  return (
    <FormGroup>
      <Label for="Intercambio">Intercâmbio por digitacao</Label>
      <AsyncSelect
        cacheOptions
        defaultOptions={false}  // Busca só após digitar 3 letras
        loadOptions={loadOptions}
        onChange={handleChange}
        placeholder="Digite ao menos 3 letras para buscar"
        isClearable
        minInputLength={3}  // Configura a busca para começar após 3 letras
      />
    </FormGroup>
  );
};


export const ComboboxIntercambio_consulta = ({ onChange }) => {
  const [cookie] = useCookies(['_csrf_token']);
  const [inputValue, setInputValue] = useState('');
  const [optionsCache, setOptionsCache] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null); // Valor inicial padrão nulo
  const [isLocked, setIsLocked] = useState(false);

  const loadOptions = async (inputValue, callback) => {
    // Se o usuário digitar exatamente 3 letras, faz uma nova requisição à API
    if (inputValue.length === 3) {
      try {
        const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
          proc: 'FRONT_Permissao_Obter_Intercambio',
          requestData: { query: inputValue }
        }, {
          headers: {
            "X-CSRF-Token": cookie?._csrf_token
          }
        });

        const options = response.data.map((inter) => ({
          value: inter.ID_Intercambio,
          label: inter.Intercambio,
        }));

        setOptionsCache(options); // Atualiza o cache com os novos dados
        callback(options);
        setIsLocked(true); // Travar novas requisições até que o usuário digite menos de 3 letras novamente

        // Se houver opções, seleciona automaticamente a primeira
        if (options.length > 0) {
          setSelectedOption(options[0]);
          onChange(options[0].value); // Define a primeira opção como selecionada
        }

      } catch (err) {
        console.error("Erro ao carregar intercâmbios:", err);
        callback([]);
      }
    } 
    // Se o usuário digitar mais de 3 letras, faz a filtragem local usando o cache
    else if (inputValue.length > 3) {
      const filteredOptions = optionsCache.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    } 
    // Se tiver menos de 3 letras, limpa as opções
    else {
      callback([]);
      setIsLocked(false); // Libera o bloqueio de novas buscas quando o número de letras diminui
    }
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    onChange(selectedOption ? selectedOption.value : '');
  };

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
  };

  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%'
    }),
    control: (provided) => ({
      ...provided,
      width: '100%'
    }),
    valueContainer: (provided) => ({
      ...provided,
      width: '100%'
    }),
    menu: (provided) => ({
      ...provided,
      width: '100%'
    })
  };

  return (
    <FormGroup>
      <Label for="Intercambio">Intercâmbio 3 letras</Label>
      <InputGroup style={{ width: '100%' }}>
        <AsyncSelect
          cacheOptions
          defaultOptions={optionsCache}
          loadOptions={loadOptions}
          onChange={handleChange}
          value={selectedOption} // Mantém a opção selecionada
          placeholder="Digite ao menos 3 letras"
          isClearable
          inputValue={inputValue}
          onInputChange={handleInputChange}
          styles={customStyles}
          required={false}
        />
      </InputGroup>
    </FormGroup>
  );
};

export const ComboboxGrupoDocumento = ({ onChange, value }) => {

  console.log('ComboboxGrupoDocumento', value);

  const [cookie] = useCookies(['_csrf_token']);
  const [allOptions, setAllOptions] = useState([]);
  const [displayedOptions, setDisplayedOptions] = useState([]);
  const [displayCount, setDisplayCount] = useState(10); // Inicialmente exibe 10 itens
  const [selectedOption, setSelectedOption] = useState(value || null); // Seta o valor inicial

  // Efeito para buscar todas as opções quando o valor inicial não estiver disponível
  useEffect(() => {
    if (value === null) { // Se já tivermos o valor inicial, não fazemos a consulta à API
      const fetchAllOptions = async () => {
        try {
          const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
            proc: 'FRONT_Permissao_Obter_Grupo_Documento', // API para buscar grupos de documento
            requestData: { query: '' }
          }, {
            headers: {
              "X-CSRF-Token": cookie?._csrf_token
            }
          });

          const grupoDocumentoOptions = response.data.map((doc) => ({
            value: doc.ID_Documento_Grupo,
            label: doc.Grupo_de_Documentos,
          }));

          setAllOptions(grupoDocumentoOptions); // Salva todas as opções de grupo de documento
          setDisplayedOptions(grupoDocumentoOptions.slice(0, displayCount)); // Mostra apenas os primeiros itens
        } catch (error) {
          console.error("Erro ao carregar grupos de documentos:", error);
        }
      };

      fetchAllOptions();
    } else {
      // Se o valor já foi passado, setamos ele diretamente
      setSelectedOption(value);
    }
  }, [cookie, displayCount, value]);

  // Função para carregar as opções conforme o usuário digita
  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = allOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    } else {
      callback(displayedOptions);
    }
  };

  // Função para carregar mais opções ao rolar a lista
  const handleScroll = () => {
    const nextCount = displayCount + 10;
    const newOptions = allOptions.slice(0, nextCount);
    setDisplayedOptions(newOptions);
    setDisplayCount(nextCount);
  };

  return (
    <div className="mb-3">
      <InputSelectCustom
        name={"Grupo Documento"}
        stateSelected={selectedOption}
        optionsData={displayedOptions}
        placeholder="Selecione um grupo de documentos"
        isClearable={true}
        loadOptions={loadOptions}
        handleOnMenuScrollToBottom={handleScroll}
        handleOnChange={(selected) => {
          setSelectedOption(selected); // Atualiza o estado local
          onChange(selected); // Propaga a mudança ao componente pai
        }}
      />
    </div>
  );
};


export const ComboboxGrupoDocumento_novo = ({ onChange, value }) => {
  const [cookie] = useCookies(['_csrf_token']);
  const [allOptions, setAllOptions] = useState([]);
  const [displayedOptions, setDisplayedOptions] = useState([]);
  const [displayCount, setDisplayCount] = useState(10); // Inicialmente exibe 10 itens
  const [selectedOption, setSelectedOption] = useState(value || null); // Seta o valor inicial

  useEffect(() => {
    if (value === null) {
      const fetchAllOptions = async () => {

        try {
          const response = await axios.post(
            `${config.URL_SERVER}/execute-procedure`,
            {
              proc: 'FRONT_Permissao_Obter_Grupo_Documento',
              requestData: { query: '' },
            },
            {
              headers: {
                'X-CSRF-Token': cookie?._csrf_token,
              },
            }
          );

          const empresasOptions = response.data.map((empresa) => ({
            value: empresa.ID_Documento_Grupo,
            label: empresa.Grupo_de_Documentos,
          }));

          setAllOptions(empresasOptions); // Salva todas as opções de empresa
          setDisplayedOptions(empresasOptions.slice(0, displayCount)); // Mostra apenas os primeiros itens
        } catch (error) {
          console.error("Erro ao carregar grupos de documentos:", error);
        }
      };

   fetchAllOptions();
    } else {
      // Se o valor já foi passado, setamos ele diretamente
      setSelectedOption(value);
    }
    
   }, [ cookie, displayCount, value]);


  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = allOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    } else {
      callback(displayedOptions);
    }
  };

  const handleScroll = () => {
    const nextCount = displayCount + 10;
    const newOptions = allOptions.slice(0, nextCount);
    setDisplayedOptions(newOptions);
    setDisplayCount(nextCount);
  };

  return (
    <div className="mb-3">
      <AsyncSelect
        cacheOptions
        defaultOptions={displayedOptions} // Exibe as opções carregadas
        loadOptions={loadOptions}
         onChange={(selected) => {
          setSelectedOption(selected); // Atualiza o estado local
          onChange(selected); // Propaga a mudança ao componente pai
        }}
        onMenuScrollToBottom={handleScroll}
        classNamePrefix="select-custom-styled"
        placeholder="Selecione um grupos de documentos"
        isClearable={true}
        value={allOptions.find(option => option.value === (value?.value ?? value)) || null} // Pre-seleciona a empresa correta, inclusive com valor 0
      />
    </div>
  );
};


export const ComboboxEmpresaPlanta = ({ ID_Empresa, onChange, value }) => {
  const [cookie] = useCookies(['_csrf_token']);
  const [allOptions, setAllOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(value || null);

  // Carrega plantas quando o ID_Empresa muda
  useEffect(() => {
    if (ID_Empresa !== null && ID_Empresa !== undefined) {
      const fetchPlantas = async () => {
        try {
          const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
            proc: 'FRONT_Permissao_Obter_Planta',
            requestData: { "ID_Empresa": ID_Empresa }
          }, {
            headers: {
              "X-CSRF-Token": cookie?._csrf_token
            }
          });

          const plantasData = response.data.map(planta => ({
            value: planta.ID_Planta,
            label: planta.Planta
          }));

          setAllOptions(plantasData);

          // Se não houver valor inicial, define a primeira planta da lista como selecionada
          if (!value && plantasData.length > 0) {
            setSelectedOption(plantasData[0]);
            onChange(plantasData[0]);
          }
        } catch (err) {
          console.error("Erro ao carregar plantas:", err);
        }
      };

      fetchPlantas();
    }
  }, [ID_Empresa, cookie, value, onChange]);

  // Função para carregar opções dinamicamente no AsyncSelect
  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = allOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    } else {
      callback(allOptions);
    }
  };

  return (
    <div className="mb-3">
      <AsyncSelect
        cacheOptions
        defaultOptions={allOptions}
        loadOptions={loadOptions}
        onChange={(selected) => {
          setSelectedOption(selected);
          onChange(selected); // Propaga a mudança ao componente pai
        }}
        value={selectedOption}
        placeholder="Selecione uma planta"
        isClearable={true}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          colors: {
            ...theme.colors,
            primary25: "#0000001F",
            primary: "#0000001F",
          },
        })}
        styles={{
          indicatorSeparator: (baseStyles, state) => ({
            ...baseStyles,
            display: "none",
          }),
          option: (baseStyles, state) => ({
            ...baseStyles,
            color: "#0F1D42",
            fontSize: 15,
            height: 44,
            alignContent: "center",
            fontWeight: "500",
          }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? "#244EA2" : "#0000001F",
            borderWidth: 1,
            height: 44,
            ":hover": {
              borderColor: "#244EA2",
            },
          }),
        }}
      />
    </div>
  );
};

export const ComboboxEmpresa = ({ ID_Usuario, onChange, value }) => {

  console.log('ComboboxEmpresa', value)

  const [cookie] = useCookies(['_csrf_token']);
  const [allOptions, setAllOptions] = useState([]);
  const [displayedOptions, setDisplayedOptions] = useState([]);
  const [displayCount, setDisplayCount] = useState(10); // Inicialmente exibe 10 itens
  const [selectedOption, setSelectedOption] = useState(value || null); // Seta o valor inicial

  // Efeito para buscar todas as opções quando o valor inicial não estiver disponível
  useEffect(() => {
    if (value === null) {// Se já tivermos o valor inicial, não fazemos a consulta à API
      const fetchAllOptions = async () => {
        try {

          const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
            proc: 'FRONT_Permissao_Obter_Empresa',
            requestData: { "ID_Usuario": ID_Usuario, query: '' }
          }, {
            headers: {
              "X-CSRF-Token": cookie?._csrf_token
            }
          });

          const empresasOptions = response.data.map((empresa) => ({
            value: empresa.ID_Empresa,
            label: empresa.Empresa,
          }));

          setAllOptions(empresasOptions); // Salva todas as opções de empresa
          setDisplayedOptions(empresasOptions.slice(0, displayCount)); // Mostra apenas os primeiros itens
        } catch (error) {
          console.error("Erro ao carregar empresas:", error);
        }
      };

      fetchAllOptions();
    } else {
      // Se o valor já foi passado, setamos ele diretamente
      setSelectedOption(value);
    }
  }, [ID_Usuario, cookie, displayCount, value]);

  // Função para carregar as opções conforme o usuário digita
  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = allOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    } else {
      callback(displayedOptions);
    }
  };

  // Função para carregar mais opções ao rolar a lista
  const handleScroll = () => {
    const nextCount = displayCount + 10;
    const newOptions = allOptions.slice(0, nextCount);
    setDisplayedOptions(newOptions);
    setDisplayCount(nextCount);
  };

  return (
    <div>
      <InputSelectCustom
        name={"Empresa Parceira"}
        stateSelected={selectedOption}
        optionsData={displayedOptions}
        placeholder="Selecione uma empresa"
        isClearable={true}
        loadOptions={loadOptions}
        handleOnMenuScrollToBottom={handleScroll}
        handleOnChange={(selected) => {
          setSelectedOption(selected);
          onChange(selected);
        }}
      />
    </div>
  );
};

export const ComboboxPlantaParceira = ({ ID_Empresa_Parceira, onChange, value }) => {
  const [cookie] = useCookies(['_csrf_token']);
  const [allOptions, setAllOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(value || null);

  // Carrega plantasParceira quando o ID_Empresa_Parceira muda
  useEffect(() => {
    if (ID_Empresa_Parceira !== null && ID_Empresa_Parceira !== undefined) {
      const fetchPlantasParceira = async () => {
        try {
          const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
            proc: 'FRONT_Permissao_Obter_Planta_Parceira',
            requestData: { "ID_Empresa_Parceira": ID_Empresa_Parceira }
          }, {
            headers: {
              "X-CSRF-Token": cookie?._csrf_token
            }
          });

          const plantasParceiraData = response.data.map(plantaParceira => ({
            value: plantaParceira.ID_Planta_Parceira,
            label: plantaParceira.Planta_Parceira
          }));

          setAllOptions(plantasParceiraData);

          // Se não houver valor inicial, define a primeira planta da lista como selecionada
          if (!value && plantasParceiraData.length > 0) {
            setSelectedOption(plantasParceiraData[0]);
            onChange(plantasParceiraData[0]);
          }
        } catch (err) {
          console.error("Erro ao carregar plantasParceira:", err);
        }
      };

      fetchPlantasParceira();
    }
  }, [ID_Empresa_Parceira, cookie, value, onChange]);

  // Função para carregar opções dinamicamente no AsyncSelect
  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = allOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    } else {
      callback(allOptions);
    }
  };

  return (
    <div className="mb-3 templating-select">
      <AsyncSelect
        cacheOptions
        defaultOptions={allOptions}
        loadOptions={loadOptions}
        onChange={(selected) => {
          setSelectedOption(selected);
          onChange(selected); // Propaga a mudança ao componente pai
        }}
        value={selectedOption}
        classNamePrefix="select-custom-styled"
        placeholder="Selecione uma planta parceira"
        isClearable={true}
        styles={{
          menu: (provided) => ({
            ...provided,
            overflowY: 'auto', // Apenas a rolagem interna, sem altura fixa
          }),
          control: (provided) => ({
            ...provided,
            width: '100%' // Garante que o combobox ocupe toda a largura do contêiner
          })
        }}
      />
    </div>
  );
};

export const ComboboxPlantaParceira_old = ({ ID_Empresa_Parceira, onChange, value }) => {
  const [plantasParceiras, setPlantasParceiras] = useState([]); // Inicialmente vazio
  const [loading, setLoading] = useState(false); // Estado de carregamento
  const [selectedOption, setSelectedOption] = useState(value); // Inicializamos com o value passado como prop
  const [cookie] = useCookies(['_csrf_token']);

  // Log para depurar o valor inicial que está sendo passado
  console.log('ComboboxPlantaParceira value (initial):', value);

  // Efeito para setar o valor inicial se ele for passado e válido
  useEffect(() => {
    if (value !== null && value !== undefined) {
      console.log('Setting initial value:', value);
      setSelectedOption(value); // Seta o valor inicial corretamente ao editar
    }
  }, [value]);

  // Efeito para carregar plantas parceiras quando o ID_Empresa_Parceira muda ou se o value for null ou undefined
  useEffect(() => {
    const fetchPlantas = async () => {
      // Se o value for passado (no caso de edição), não sobrescreva
      if (value && value !== undefined) {
        return; // Se estamos editando e o value está presente, não fazemos a requisição de plantas
      }

      // Se a empresa parceira selecionada for "TODAS" (ID_Empresa_Parceira === 0)
      if (ID_Empresa_Parceira === 0) {
        console.log('ID_Empresa_Parceira is 0, setting planta to "TODAS"');
        setPlantasParceiras([{ ID_Planta_Parceira: 0, Planta_Parceira: 'TODAS' }]); // Mostramos a opção "TODAS" para planta parceira
        setSelectedOption({ value: 0, label: 'TODAS' });
        if (onChange) {
          onChange({ value: 0, label: 'TODAS' }); // Propagamos a planta "TODAS"
        }
      } else if (ID_Empresa_Parceira) {
        // Se não for "TODAS", carregamos as plantas parceiras normalmente via API
        try {
          setLoading(true); // Inicia o carregamento ao mudar a empresa parceira
          const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
            proc: 'FRONT_Permissao_Obter_Planta_Parceira',
            requestData: { "ID_Empresa_Parceira": ID_Empresa_Parceira }
          }, {
            headers: {
              "X-CSRF-Token": cookie?._csrf_token
            }
          });

          const plantasData = response.data;
          setPlantasParceiras(plantasData); // Atualiza a lista de plantas parceiras com base na resposta

          // Se não houver valor inicial, define a primeira planta da lista como selecionada
          if (plantasData.length > 0 && !value) { // Somente seleciona a planta da lista se não estiver em edição (sem value)
            console.log('Setting default plant from API:', plantasData[0]);
            setSelectedOption({ value: plantasData[0].ID_Planta_Parceira, label: plantasData[0].Planta_Parceira });
            if (onChange) {
              onChange({ value: plantasData[0].ID_Planta_Parceira, label: plantasData[0].Planta_Parceira });
            }
          }
        } catch (err) {
          console.log("Erro ao carregar plantas parceiras:", err);
        } finally {
          setLoading(false); // Finaliza o carregamento
        }
      }
    };

    // Só faz a chamada se o ID_Empresa_Parceira estiver presente
    if (ID_Empresa_Parceira !== null && ID_Empresa_Parceira !== undefined) {
      fetchPlantas();
    }
  }, [ID_Empresa_Parceira, cookie, value]); // O useEffect só roda se o ID_Empresa_Parceira mudar ou se o value for null ou undefined

  // Função que será chamada quando o usuário mudar a planta no select
  const handleSelectChange = (e) => {
    const selectedPlantaId = parseInt(e.target.value, 10);
    console.log('Selected plant ID:', selectedPlantaId);

    // Atualiza a seleção localmente
    const selectedPlanta = plantasParceiras.find(planta => planta.ID_Planta_Parceira === selectedPlantaId);
    if (selectedPlanta) {
      console.log('Setting selected plant:', selectedPlanta);
      setSelectedOption({ value: selectedPlanta.ID_Planta_Parceira, label: selectedPlanta.Planta_Parceira });
      onChange({ value: selectedPlanta.ID_Planta_Parceira, label: selectedPlanta.Planta_Parceira }); // Propaga a mudança para o componente pai
    }
  };

  return (
    <Input 
      type="select" 
      value={selectedOption ? selectedOption.value : ''} // Aqui garantimos que o value seja setado corretamente
      onChange={handleSelectChange} 
      required
    >
      <option value="" disabled>Selecione uma planta parceira</option>
      {plantasParceiras.length > 0 ? plantasParceiras.map((planta) => (
        <option key={planta.ID_Planta_Parceira} value={planta.ID_Planta_Parceira}>
          {planta.Planta_Parceira}
        </option>
      )) : (
        <option value={selectedOption?.value}>{selectedOption?.label}</option>
      )}
    </Input>
  );
};




export const ComboboxDocumento = ({ ID_Documento_Grupo, onChange, value }) => {
  const [cookie] = useCookies(['_csrf_token']);
  const [allOptions, setAllOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(value || null);

  // Carrega documentos quando o ID_Documento_Grupo muda
  useEffect(() => {
    if (ID_Documento_Grupo !== null && ID_Documento_Grupo !== undefined) {
      const fetchDocumentos = async () => {
        try {
          const response = await axios.post(`${config.URL_SERVER}/execute-procedure`, {
            proc: 'FRONT_Permissao_Obter_Documento',
            requestData: { "ID_Documento_Grupo": ID_Documento_Grupo }
          }, {
            headers: {
              "X-CSRF-Token": cookie?._csrf_token
            }
          });

          const documentosData = response.data.map(documento => ({
            value: documento.ID_Documento,
            label: documento.Documento
          }));

          setAllOptions(documentosData);

          // Se não houver valor inicial, define a primeira documento da lista como selecionada
          if (!value && documentosData.length > 0) {
            setSelectedOption(documentosData[0]);
            onChange(documentosData[0]);
          }
        } catch (err) {
          console.error("Erro ao carregar documentos:", err);
        }
      };

      fetchDocumentos();
    }
  }, [ID_Documento_Grupo, cookie, value, onChange]);

  // Função para carregar opções dinamicamente no AsyncSelect
  const loadOptions = (inputValue, callback) => {
    if (inputValue) {
      const filteredOptions = allOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    } else {
      callback(allOptions);
    }
  };

  return (
    <div className="mb-3 templating-select">
      <AsyncSelect
        cacheOptions
        defaultOptions={allOptions}
        loadOptions={loadOptions}
        onChange={(selected) => {
          setSelectedOption(selected);
          onChange(selected); // Propaga a mudança ao componente pai
        }}
        value={selectedOption}
        classNamePrefix="select-custom-styled"
        placeholder="Selecione uma documento"
        isClearable={true}
        styles={{
          menu: (provided) => ({
            ...provided,
            overflowY: 'auto', // Apenas a rolagem interna, sem altura fixa
          }),
          control: (provided) => ({
            ...provided,
            width: '100%' // Garante que o combobox ocupe toda a largura do contêiner
          })
        }}
      />
    </div>
  );
};